<template>
    <v-dialog v-model="enabled" persistent>
        <v-card>
            <v-toolbar color="indigo" dark flat><v-toolbar-title>撮影</v-toolbar-title></v-toolbar>
            <v-container>
                <v-row>
                    <v-col>
                        <v-select
                            v-model="selectedDeviceID"
                            label="カメラ" 
                            outlined
                            :items="cameraDevices" 
                            item-text="label" 
                            item-value="deviceId"
                            @change="onSelectedCamera" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-alert type="error" v-if="readerError!=null">Error!! {{readerError}}</v-alert>
                        <!-- <WebCam ref="camera" selectFirstDevice="true" autoplay="true" /> -->
                        <WebCam 
                            ref="camera" 
                            @cameras="onLoadedCameras" />
                    </v-col>
                </v-row>                
            </v-container>
            <v-card-actions>
                <v-btn color="primary" @click="onClickCapture()">撮影</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="onClickCancel()">キャンセル</v-btn>
            </v-card-actions>
        </v-card>
        <Confirm ref="confirm" />    
    </v-dialog>
</template>

<script>
    import {WebCam} from 'vue-web-cam'
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        name: 'CaptureCamera',
        components: {
            WebCam,
            Confirm
        },
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            enabled: {
                get: function() {return this.$props.value},
                set: function(v) {
                    this.$emit("input", v)
                }
            }
        },
        watch: {
            enabled: function (value, old) {
                console.log("camera enable value changed", value)
                if (value == true) {
                    if (this.cameraDevices != null) {
                        this.onLoadedCameras(this.cameraDevices)
                    }
                }
            }
        },
        created: function () {
            console.log("CaptureCamera", "created")
        },
        data: () => ({
            readerError: null,
            selectedDeviceID: "",
            cameraDevices: null
        }),
        methods: {
            onLoadedCameras: function (cameras) {
                // console.log("CaptureCamera", "onLoadedCameras", cameras, cameras.length)
                this.cameraDevices = cameras
                if (cameras.length == 1) {
                    this.selectedDeviceID = cameras[0].deviceId
                    this.onSelectedCamera()
                }
            },
            onSelectedCamera: function () {
                this.$refs.camera.changeCamera(this.selectedDeviceID)
                this.$refs.camera.start()
            },
            onClickCapture: async function () {
                const self = this
                this.$refs.camera.pause()
                this.$refs.confirm.show({
                    title: "撮影",
                    message: "この写真で宜しいですか？",
                    width: 400,
                    buttonYes: "OK",
                    buttonNo: "やり直し",
                    listenerYes: function () {
                        var capturedData = self.$refs.camera.capture()                    
                        self.$emit("onCaptured", capturedData)
                        self.enabled = false
                        return true
                    },
                    listenerNo: function () {
                        self.$refs.camera.start()
                        return true
                    }
                })

                // if (await this.$refs.confirm.open('撮影', 'この写真で宜しいですか？', { color: 'blue' })) {
                //     var capturedData = this.$refs.camera.capture()                    
                //     this.$emit("onCaptured", capturedData)
                //     this.isView = false
                // } else {
                //     this.$refs.camera.start()
                // }
            },
            onClickCancel: function() {
                this.enabled = false
            },
        }
    }
</script>
